import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { sheetTone } from './sheetStyles';

/**
 * The Project / Track / Goal × Planned / Actual grid at the top of the sheet.
 *
 * Entirely derived from the period's tasks and action items, so it is read-only:
 * the numbers come from the server (live while the report is editable, frozen
 * once it is finalized) and are never typed in.
 */
const GoalTable = ({ lines = [] }) => {
  const colors = sheetTone(useTheme());

  const headCell = {
    backgroundColor: colors.header,
    borderColor: colors.border,
    fontWeight: 700,
    whiteSpace: 'nowrap',
  };
  const bodyCell = { borderColor: colors.border };
  const numCell = { ...bodyCell, textAlign: 'right', whiteSpace: 'nowrap' };

  return (
    <Box sx={{ overflowX: 'auto', mb: 2, border: '1px solid', borderColor: colors.border }}>
      <Table size="small" sx={{ minWidth: 780, '& td, & th': { border: '1px solid' } }}>
        <TableHead>
          <TableRow>
            <TableCell sx={headCell} rowSpan={2}>Project</TableCell>
            <TableCell sx={headCell} rowSpan={2}>Track</TableCell>
            <TableCell sx={headCell} rowSpan={2}>Goal</TableCell>
            <TableCell sx={{ ...headCell, textAlign: 'center' }} colSpan={3}>Planned</TableCell>
            <TableCell sx={{ ...headCell, textAlign: 'center' }} colSpan={3}>Actual</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={headCell}>Tasks</TableCell>
            <TableCell sx={headCell}>AI</TableCell>
            <TableCell sx={headCell}>Est time</TableCell>
            <TableCell sx={headCell}>Tasks</TableCell>
            <TableCell sx={headCell}>AI</TableCell>
            <TableCell sx={headCell}>Time taken</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lines.length === 0 ? (
            <TableRow>
              <TableCell sx={bodyCell} colSpan={9}>
                <Typography variant="body2" color="text.secondary">
                  No tracked work in this period.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            lines.map((line) => (
              <TableRow key={line.track_id}>
                <TableCell sx={bodyCell}>{line.project}</TableCell>
                <TableCell sx={bodyCell}>{line.track}</TableCell>
                <TableCell sx={bodyCell}>{line.goal || '—'}</TableCell>
                <TableCell sx={numCell}>{line.planned_tasks}</TableCell>
                <TableCell sx={numCell}>{line.planned_action_items}</TableCell>
                <TableCell sx={numCell}>{line.planned_est_time}</TableCell>
                <TableCell sx={numCell}>{line.actual_tasks}</TableCell>
                <TableCell sx={numCell}>{line.actual_action_items}</TableCell>
                <TableCell sx={numCell}>{line.actual_time_taken} hrs</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default GoalTable;
